// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";  
// import cold from "../../assets/Coal-Import-Monitoring-System-1.jpg";


// export default function Cold() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Cold Chain from MOFPI</h1>

//                                   <h2>Integrated Cold Chain Scheme</h2> 
//                                   <p>The aim of the cold chain infrastructure, value creation and maintenance system are to provide integrated facilities of the cold chain infrastructure and the maintenance infrastructure without interruptions from the producer to the consumer. Pre-cooling, weighing, sorting, sorting, waxing systems at farm level, multi-product / multi-temperature cold storage, CA storage, packaging systems, IQF, distribution center for quick freezing and refrigerated vehicles, mobile cooling units to facilitate the distribution of horticulture, organic farming, seafood, dairy products, Meat and poultry products, etc. The allows flexibility in project planning with a particular focus on creating a cold chain infrastructure at the farm level. ,</p>
//                                   <p>The integrated cold chain project is set up by Partnership / Proprietorship Firms, Companies, Corporations, Cooperatives, Self-Help Groups (SHGs), Formarl Producer Organizations (FPOs), NGOs, Central / State UPMs, etc., subject to compliance with the eligibility requirements of the scheme guidelines of cold chain . The scheme has been in implementation since 2008. To see the implementation status of the cold chain projects.</p>
                                  
                                                                   
//                                 </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Project Components</h2>
//                                   <p>The scheme aims to facilitate the establishment of a strong cold chain for agricultural, horticultural, dairy, fishery and marine, poultry and meat products by creating end-to-end connections from the farm entrance to the Consumers produced efficient storage. Minimal transportation and processing. The various components of the cold chain projects are as follows:</p>

//                                   <ul>
//                                       <li>The minimum processing center at farm level and the centers must have facilities for weighing, classifying, classifying, waxing, packaging, pre-cooling, Multie Control Atmosphere (CA) / Modified Atmosphere (MA) have cold storage, normal storage and individual Quick freezing (IQF).</li>
//                                       <li>Mobile pre-refrigerated vehicles and refrigerated vehicles.</li>
//                                       <li>Distribution centers with multiple products and multiple control atmospheres (CA) / modified atmospheres (MA) / cold rooms / chambers with variable humidity, packaging systems, cleaning in process (CIP) mist treatment, individual Quick freezing (IQF) and shock freezing.</li>
//                                       <li>Irradiation facility.</li>
//                                   </ul>

//                                   <img src={cold} alt="Cold Chain" className="img-fluid b-block mx-auto mb-3" />

//                                   <h2>Pattern of Assistance:</h2>
//                                   <p>Financial Assistance (grant) under the scheme is limited to a maximum of 10 million rupees per project for civil engineering works and eligible plant and machinery, subject to the following:</p>
//                                   <p>For the storage infrastructure, including packaging unit and pre-cooling unit, ripening room and transport. Infrastructure, a grant of 35% for general areas and 50% for northeast states, Himalayan states, ITDP areas and islands of the total costs of the systems and machines as well as the technical construction work are provided.</p>
//                                   <p>The value creation and processing infrastructure, including associated and integrated freezer storage / freezers for processing, will receive a grant of 50% for general areas and 75% for Northeast States, Himalayan States, Territories and ITDP Islands.</p>
//                                   <p>For irradiation facilities grant-in-aid will be grant is 50% for general areas and 75% for northeast states, Himalayan states, ITDP areas and islands.</p>


//                                   <h2>Release of Grant</h2>
//                                   <p>The grant-in-aid under the scheme is released in three instalments of 25%, 40% and 35% as per following schedule:</p>
//                                   <p>1 st installment of 25% of the total grant under the scheme will be released after ensuring that 25% of the promoter's contribution and 25% of the temporary loan have been spent on the project;</p>
//                                   <p>2 nd Installment of a further 40% of the total grant will be released after ensuring that the first installment of the grant, 65% of the promoter contribution and 65% of the installment loan are used;</p>
//                                   <p>3 rd and final installment of the remaining 35% of the grant grant will be released after the use in the second installment and 100% of the promoter's contribution and 100% of the fixed-term loan have been guaranteed.</p>
                            
//                                   <h2>How do we support you?</h2>
//                                   <p>Enrichservices offers you a comprehensive solution for construction and cold store projects: Our solutions are cost-effective, clearly defined, technically mature and delivered on time</p>
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function ColdChain() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Integrated Cold Chain Scheme
              </h1>

              <p>
                The Integrated Cold Chain and Value Addition Infrastructure Scheme
                is a Government initiative aimed at building a seamless cold chain
                from farm to consumer.
              </p>

              <p>
                It ensures product freshness, reduces wastage, and improves
                profitability across perishable sectors.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Build end-to-end cold chain infrastructure</li>
            <li><FaCheckCircle /> Minimize post-harvest losses</li>
            <li><FaCheckCircle /> Improve shelf life and quality</li>
            <li><FaCheckCircle /> Enhance value addition</li>
            <li><FaCheckCircle /> Strengthen supply chain efficiency</li>
          </ul>

          {/* SECTORS */}
          <h2 className="section-title">
            <FaList className="icon" /> Supported Sectors
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Fruits & vegetables</li>
            <li><FaCheckCircle /> Dairy products</li>
            <li><FaCheckCircle /> Meat & poultry</li>
            <li><FaCheckCircle /> Fisheries & marine</li>
            <li><FaCheckCircle /> Organic produce</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Private companies & entrepreneurs</li>
            <li><FaCheckCircle /> Partnerships & firms</li>
            <li><FaCheckCircle /> Cooperatives & NGOs</li>
            <li><FaCheckCircle /> FPOs & SHGs</li>
            <li><FaCheckCircle /> Government entities</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Project Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Pre-cooling & farm-level infrastructure</li>
            <li><FaCheckCircle /> Cold storage & CA/MA systems</li>
            <li><FaCheckCircle /> Refrigerated transport</li>
            <li><FaCheckCircle /> Processing & packaging units</li>
            <li><FaCheckCircle /> IQF & freezing systems</li>
            <li><FaCheckCircle /> Ripening & irradiation facilities</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 35% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & difficult areas)</li>
            <li><FaCheckCircle /> Up to ₹10 Crores per project</li>
          </ul>

          {/* VALUE ADD */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Value Addition Subsidy
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 50% subsidy (general areas)</li>
            <li><FaCheckCircle /> 75% subsidy (special regions)</li>
          </ul>

          {/* GRANT */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Grant Release
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 1st Installment – 25%</li>
            <li><FaCheckCircle /> 2nd Installment – 40%</li>
            <li><FaCheckCircle /> Final Installment – 35%</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including DPR preparation,
            technical planning, subsidy application, and coordination with authorities
            to ensure smooth execution and funding.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> End-to-end project planning</li>
            <li><FaCheckCircle /> Bankable DPR preparation</li>
            <li><FaCheckCircle /> Technology guidance</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Post-project support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}